import { numberToPrettyString } from '@cian/utils';

import template from './living-area.jade';
import validation from './../../../services/validation';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular.module('cian.addForm.livingArea', []).directive('cianAfAboutObjectLivingArea', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'isSimpleFormEnabled',
    'adTooltipsService',
    '$scope',
    'analyticsService',
    'deviceService',
    'popupService',
    function (isSimpleFormEnabled, adTooltipsService, $scope, analyticsService, deviceService, popupService) {
      this.getFieldLabel = () => (isSimpleFormEnabled() ? 'Жилая' : 'Жилая площадь');

      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Подсказка';
      this.tooltipText = '';
      this.areaMax = 100000;
      this.areaMin = 0;

      this.validation = validation(this.form, 'livingArea', {
        parse: 'Введите число',
        min: `Площадь должна быть больше ${this.areaMin}`,
        max: `Допустимо не более ${numberToPrettyString(this.areaMax)} м²`,
      });

      // Число выбрано исходя из сообщений выше
      const MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP = 50;

      this.shouldTooltipOpen = () => this.validation.message().length <= MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP;

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'livingArea',
        trackingLabel: 'living-area-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
  ],
  controllerAs: 'livingArea',
  template,
})).name;
